import { ModalUtils, NeoModel, Validation } from '@singularsystems/neo-core';
import { Views } from '@singularsystems/neo-react';
import { AppService, Types } from '../../../App/Services/AppService';
import FileSpecLookup from '../Models/Lookups/FileSpecLookup';
import { enumFileDelimiter } from './FileDelimiterEnum';
import { enumFileExtension } from './FileExtensionEnum';
import { TextConstants } from '../../../Common/TextConstants';

@NeoModel
export default class ManageFileSpecVM extends Views.ViewModelBase {

    constructor(
        public fileSpecApiClient = AppService.get(Types.ApiClients.FileSpecApiClient),
        taskRunner = AppService.get(Types.Neo.TaskRunner)) {
            super(taskRunner);
        }    

    public fileSpecLookupModel = new FileSpecLookup();
    public showManageFileSpecComponent: boolean = false;
    public isFieldReadOnlyInd: boolean = false;
    public updateFileSpecReadOnlyInd: boolean = false;
    public activeEndDateIsNull: boolean = false;
    public confirmSaveInd: boolean = false;
    public showConfirmSaveComponent: boolean = false;
    public validationModeDisplay = Validation.DisplayMode.AfterSubmit;
    
    public initialise() {

    }

    public toggleActiveEndDateSetToNull() {
        this.activeEndDateIsNull = !this.activeEndDateIsNull;
    }

    public closeConfirmationModal() {
        this.showConfirmSaveComponent = false;
    }

    public showConfirmSaveModal() {
        if(!this.isValid) {
            ModalUtils.showMessage(TextConstants.Titles.Error, TextConstants.Notifications.MissingRequiredFields);
            this.validationModeDisplay = Validation.DisplayMode.Always;
        }
        else
        {
            this.showConfirmSaveComponent = true;
        }
    }

    public confirmSave() {
        this.confirmSaveInd = true;
        this.closeConfirmationModal();
    }

    public getDelimiterEnumFromString(input: string | null){
        switch(input){
            case "Tab": return enumFileDelimiter.Tab;
            case "Semicolon": return enumFileDelimiter.Semicolon;
            case "Space": return enumFileDelimiter.Space;
            case "Comma": return enumFileDelimiter.Comma;
            case "Pipe": return enumFileDelimiter.Pipe;
            default: return null;
        }
    }

    public getExtensionEnumFromString(input: string | null){
        switch(input){
            case ".csv": return enumFileExtension.csv;
            case ".prn": return enumFileExtension.prn;
            case ".txt": return enumFileExtension.txt;
            case ".xls": return enumFileExtension.xls;
            case ".xlsm": return enumFileExtension.xlsm;
            case ".xlsx": return enumFileExtension.xlsx;
            default: return null;
        }
    }
}